// extracted by mini-css-extract-plugin
export default {"course":"EvaluationCard_course__lofQF","copy":"EvaluationCard_copy__AWovD"};